import AuditLogsSettings from '@/pages/settings/audit-logs';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/audit-logs'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <AuditLogsSettings />;
}
